/**
 * @ngdoc overview
 * @name WebCoreModule
 * @description
 * WebCore is a collection of internally developed components and extensions and is the majority of the custom code developed for the
 * Ford Responsive Framework (FRF). The WebCoreModule includes all needed vendor scripts as dependencies and also includes the custom
 * developed scripts. Applications can take advantage of all vendor and custom code via inclusion of WebCoreModule.
 */

angular.module('WebCoreModule', [
    'ngSanitize',
    'ngTouch',
    'pascalprecht.translate',
    'ui.bootstrap',
    'ui.mask',
    'ui.router',
    'ui.select',
    'WcResponsiveTableModule'
]).config(['$httpProvider', function ($httpProvider) {
    //override default $http behavior to trigger any webCore http requests to be batched into similar digest cycles.
    $httpProvider.useApplyAsync(true);
}]);

/**
 * @ngdoc service
 * @name WebCoreModule.service:_
 * @description
 * WebCore includes the underscore library. Since it's not defined in the Angular context, we define an Angular constant for it here.
 */
angular.module('WebCoreModule').constant('_', window._);

/**
 * @ngdoc service
 * @name WebCoreModule.service:XLSX
 * @description
 * WebCore includes the js-xlsx library. Since it's not defined in the Angular context, we define an Angular constant for it here.
 */
angular.module('WebCoreModule').constant('XLSX', window.XLSX);


 
angular.module('WebCoreModule').constant('ExcelJS', window.exceljs);


/**
 * @ngdoc service
 * @name WebCoreModule.service:saveAs
 * @description
 * WebCore includes the file-saver library. Since it's not defined in the Angular context, we define an Angular constant for it here.
 */
angular.module('WebCoreModule').constant('saveAs', window.saveAs);

/**
 * @ngdoc service
 * @name WebCoreModule.service:pdfMake
 * @description
 * WebCore includes the pdfMake library. Since it's not defined in the Angular context, we define an Angular constant for it here.
 */
angular.module('WebCoreModule').constant('pdfMake', window.pdfMake);

/**
 * @ngdoc service
 * @name WebCoreModule.service:Chart
 * @description
 * WebCore includes the Chart.js library. Since it's not defined in the Angular context, we define an Angular constant for it here.
 */
angular.module('WebCoreModule').constant('Chart', window.Chart);

/**
 * @ngdoc service
 * @name WebCoreModule.service:WcConstants
 * @description
 * WebCore includes a few constant values that are applicable module-wide. They are defined here as a constant service for use
 * throughout the module.
 */
angular.module('WebCoreModule').constant('WcConstants', {
    'local': 'local',
    'wslBaseUrl': 'https://www.wsl.ford.com/login.cgi?portstripping=no&back=',
    'authorization': {
        'any': 'Any',
        'all': 'All'
    },
    'version': '1.2.2',
    'name' : 'Ford Responsive Framework (FRF)'
});
angular.module('WebCoreModule').constant('Prism', window.Prism);

jQuery.fn.exists = function () {
    return this.length !== 0;
};

jQuery.fn.outerHTML = function () {
    return jQuery('<div>').append(this.eq(0).clone()).html();
};

//credit to stack overflow posters 'Michael Herold and Ryan O'Neill': http://stackoverflow.com/a/15311842
angular.merge = function (dst) {
    angular.forEach(arguments, function (obj) {
        if (obj !== dst) {
            angular.forEach(obj, function (value, key) {
                if (dst[key] && dst[key].constructor && dst[key].constructor === Object) {
                    angular.merge(dst[key], value);
                } else {
                    dst[key] = value;
                }
            });
        }
    });
    return dst;
};
